import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
/**
 * Вордмарк FoodLabs: знак-колба (Labs) плюс текстовая часть, где вторая
 * половина слова набрана акцентом. Нарисован в коде, чтобы не тянуть файл —
 * когда появится фирменный знак, меняется только содержимое Box со svg.
 */
const Logo = ({ markOnly = false, size = 34 }) => {
    return (_jsxs(Box, { sx: { display: "flex", alignItems: "center", gap: 1.25 }, children: [_jsx(Box, { sx: {
                    width: size,
                    height: size,
                    borderRadius: `${(size / 3).toFixed(0)}px`,
                    flex: "none",
                    display: "grid",
                    placeItems: "center",
                    bgcolor: "primary.main",
                    color: "common.white",
                }, children: _jsxs("svg", { width: size * 0.62, height: size * 0.62, viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true", children: [_jsx("path", { d: "M9.5 2.75h5M10.5 3v6.4l-4.6 8.2a2.1 2.1 0 0 0 1.8 3.15h8.6a2.1 2.1 0 0 0 1.8-3.15L13.5 9.4V3", stroke: "currentColor", strokeWidth: "1.7", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("path", { d: "M7.7 14.6h8.6", stroke: "currentColor", strokeWidth: "1.7", strokeLinecap: "round", opacity: "0.55" }), _jsx("circle", { cx: "10.6", cy: "17.1", r: "1", fill: "currentColor" })] }) }), !markOnly && (_jsxs(Typography, { component: "span", sx: {
                    fontSize: size * 0.53,
                    fontWeight: 800,
                    letterSpacing: "-0.035em",
                    lineHeight: 1,
                    color: "text.primary",
                    userSelect: "none",
                }, children: ["Food", _jsx(Box, { component: "span", sx: { color: "primary.main" }, children: "Labs" })] }))] }));
};
export default Logo;
